import React, { Component } from 'react';
import './Dashboard.css';
import { Link } from 'react-router-dom';
import ConsoleLog from '../../../hoc/ConsoleLog/ConsoleLog';
import DashboardBar from '../DashboardBar/DashboardBar';
import RecruiterManagement from '../RecruiterManagement/RecruiterManagement';
import Sidebar from '../../../components/UI/Sidebar/Sidebar';

/**
* @desc Recruiter Dashboard
* @version 0.1.0
* @author Jamshith,Praveen George, Lakshmikanth V
*/

class AdminDashboard extends Component {
  render() {
    return (null)
  }
}

export default AdminDashboard;



// WEBPACK FOOTER //
// ./src/container/Admin/Dashboard/Dashboard.js